import { DefaultFooter } from '@ant-design/pro-components';
import { useIntl } from '@umijs/max';
import React from 'react';

const Footer: React.FC = () => {
  const intl = useIntl();
  const defaultMessage = intl.formatMessage({
    id: 'app.copyright.produced',
    defaultMessage: 'Developed by Dev team GARENA VN',
  });

  const currentYear = new Date().getFullYear();

  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={`${currentYear} ${defaultMessage}`}
      links={[
        {
          key: 'GarenaVN',
          title: 'GarenaVN',
          href: 'https://garena.vn',
          blankTarget: true,
        },
        {
          key: 'Terms of Service',
          title: 'Terms of Service',
          href: 'https://garena.vn/terms',
          blankTarget: true,
        },
        {
          key: 'Privacy',
          title: 'Privacy Policy',
          href: 'https://garena.vn/privacy',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
